/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import AchievementHero from './AchievementHero';
import AchievementLevel from '../../../common/components/AchievementLevel';
import AchievementLevelUsers from './AchievementLevelUsers';
import Link from 'flarum/common/components/Link';

export default class AchievementPage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		const gamificationEnabled = app.forum.attribute(`${slug}.gamification.enabled`);
		if (!gamificationEnabled) {
			m.route.set('/');
		}

		this.achievementId = m.route.param('id');

		app.history.push('achievement');
		this.bodyClass = 'App--achievement';

		this.loading = false;
		this.refresh();
	}

	onbeforeupdate(vnode) {
		super.onbeforeupdate(vnode);

		const { achievement } = this;

		if (achievement) {
			app.setTitle(achievement.name());
		}
	}

	view() {
		const { achievement, loading } = this;

		return (
			<div className="AchievementPage">
				<AchievementHero achievement={achievement} loading={loading} />
				<div className="container">
					{loading && <LoadingIndicator />}
					<div className="AchievementPage-levels">
						{achievement?.levels().map((level) => (
							<Link
								href={app.route('achievement-users', {
									levelId: level.id(),
								})}
							>
								<div className="AchievementPage-level">
									<AchievementLevel achievementLevel={level} showDesc={true} />
									<AchievementLevelUsers achievementLevel={level} />
								</div>
							</Link>
						))}
					</div>
				</div>
			</div>
		);
	}

	async refresh() {
		this.loading = true;
		m.redraw();

		this.achievement = await app.store.find('achievements', this.achievementId);

		this.loading = false;
		m.redraw();
	}
}
